import { post } from "nayjax";

import { MarketoFormRules } from './marketo-form-rules';

const endpoint = "/wp-json/mkto/check-trial-user";


function serialize_array(form) {
    let arr = new Array();
    Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
        if (field.type === 'select-multiple') {
            Array.prototype.slice.call(field.options).forEach(function (option) {
                if (!option.selected) return;
                arr[field.name] = option.value
            });
            return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
            arr[field.name] = field.value
    });
    return arr;
};


window.submit_marketo_start_trial = () => {
    
    try {
        
        let mktoForm = document.querySelector('[data-form-id="1406-falcon"]');

        let formValues = serialize_array(mktoForm);

        let leadValues = { form : false, marketo : false }

        leadValues.form  = formValues;

        let leadData = false; 

        console.log('start_trial');

        if (MarketoFormRules.exists(mktoForm.getAttribute('data-form-id')) && formValues.Email) {
        
            let data = {
                email: formValues.Email,
                fields: 'Falcon_Is_Platform_User__c, LastTrialRequestDate__c'
            };

            post(endpoint, data).then((response) => {
                try {
                    response = JSON.parse(response);
                    console.log(response);
                    leadData = response[0] ? response[0] : '';
                    leadValues.marketo = leadData;

                    let location = MarketoFormRules.run(mktoForm.getAttribute('data-form-id'), leadValues);
                    
                    console.log(location);

                    document.location.href = location ? location : '/';

                    return false;

                } catch (err) { }
            });

            return false;

        }

        return false;


    } catch (err) { }

}